import { Input } from 'antd';
import PropTypes from 'prop-types';
import { EditDate, EditDateTime } from './TextTypesComponents';
import { FormEditSummaryItem } from './FormEditSummaryItem';
import { textfieldTypes } from '../../../../../config/constants/mobileFormConstant';
import { GooglePlacesAutocomplete } from '../../../../../components/geolocation/GooglePlacesAutocomplete';

export const EditSummaryTextField = ({ field, onFinish }) => {
  const inputComponents = {
    [textfieldTypes.DATETIME.name]: () => <EditDateTime />,
    [textfieldTypes.DATE.name]: () => <EditDate />,
    [textfieldTypes.GEOLOCATION.name]: () => <GooglePlacesAutocomplete />,
    default: () => <Input />,
  };

  return (
    <FormEditSummaryItem onFinish={onFinish} field={field}>
      {(inputComponents[field.typeTextField] ?? inputComponents.default)()}
    </FormEditSummaryItem>
  );
};

EditSummaryTextField.propTypes = {
  field: PropTypes.object,
  onFinish: PropTypes.func,
};
